var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('top-template',{attrs:{"title":"コッピー・プロジェクト"}}),(_vm.$route.name==='works-item')?_c('works-item'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }